<p *ngIf="header" class="header">{{ header }}</p>

<div class="selected-list" [class.is-viewing]="!canEdit">
  <ng-container *ngFor="let item of displayedSelectedList; let i = index">
    <app-pencil-pill
      [text]="item[valuePropName] | translate"
      [isRemovable]="canEdit"
      (remove)="removeSelectedItem(item)"
      class="item-pill"
      [appTooltip]="item[valuePropName] | translate"
      appTooltipPlacement="bottom-center"
      [appTooltipOffsetY]="5"
    ></app-pencil-pill>
  </ng-container>

  <app-pencil-pill
    *ngIf="moreTagsToShow"
    [text]="'+' + (selectedList.length - maxShownTags)"
    [appTooltip]="
      canExpandHiddenTags
        ? ('Click to view all tags' | translate)
        : (hiddenSelectedList | joinProperties: valuePropName:'\n')
    "
    [appTooltipPlacement]="'bottom-center'"
    [appTooltipArrow]="'top'"
    [appTooltipCreateNewLine]="true"
    [isRemovable]="false"
    class="item-pill"
    (click)="canExpandHiddenTags && showFullList()"
  ></app-pencil-pill>

  <div
    *ngIf="
      this.canEdit && this.searchBoxHidden && (addableList.length || !originalAddableList.length)
    "
    [appTooltip]="'No filter options available to add' | translate"
    [appTooltipDisabled]="originalAddableList.length"
    [appTooltipPlacement]="'bottom-center'"
    [appTooltipArrow]="'top'"
  >
    <app-pencil-button
      [ngClass]="buttonClasses"
      [disabled]="!originalAddableList.length"
      (clickEvent)="focusSearchInput()"
    >
      <app-pencil-icon name="add" [type]="IconTypes.materialIcon"></app-pencil-icon>
      <ng-container *ngIf="!selectedList.length">
        <span>{{ placeholder }}</span>
      </ng-container>
    </app-pencil-button>
  </div>

  <app-pencil-multi-select-dropdown
    (itemSelectedEmitter)="addSelectedItem($event)"
    [addableList]="addableList"
    [hasEditOption]="hasEditOption"
    [valuePropName]="valuePropName"
    [(searchBoxHidden)]="searchBoxHidden"
    [class.dropdown-shown]="!searchBoxHidden"
  ></app-pencil-multi-select-dropdown>
</div>
